export function getRequiredPasswordLength() {
  return parseInt(process.env.NEXT_PUBLIC_MIN_PASSWORD_LENGTH ?? '14');
}
